package app.model

import kotlinx.serialization.Serializable

@Serializable
data class Stage(
    val id: Int,
    val name: String,
    val ordering: Int,
)
